import { render, staticRenderFns } from "./TheLayoutWrapMenuList.vue?vue&type=template&id=0c13e40d&scoped=true&"
import script from "./TheLayoutWrapMenuList.vue?vue&type=script&lang=js&"
export * from "./TheLayoutWrapMenuList.vue?vue&type=script&lang=js&"
import style0 from "./TheLayoutWrapMenuList.vue?vue&type=style&index=0&id=0c13e40d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c13e40d",
  null
  
)

export default component.exports